import { createApi } from '@reduxjs/toolkit/query/react';

import type { GetPricesResponseSchemaType, PriceDataType } from 'src/global/schemas/price.schema';

import { REDUX_SLICE } from '../constants';
import { axiosBaseQuery } from '../utils';

export const priceApi = createApi({
  reducerPath: REDUX_SLICE.PRICE_API,
  baseQuery: axiosBaseQuery,
  tagTypes: ['Prices'],
  endpoints: builder => ({
    getPrices: builder.query<PriceDataType, void>({
      query: () => ({
        method: 'GET',
        path: '/v1/prices',
      }),
      transformResponse: (returnValue: GetPricesResponseSchemaType) => returnValue.data,
    }),
  }),
});

export const { useGetPricesQuery } = priceApi;
